export class PagingModel {

    public count: number;
    public currentPage: number;
    public perPage: number;

    constructor(obj?: any) {
        this.count          = obj && obj.total          || 0;
        this.currentPage    = obj && obj.currentPage    || 1;
        this.perPage        = obj && obj.perPage        || 20;

    }
}



// WEBPACK FOOTER //
// ./src/app/models/paging.model.ts